var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1725_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97223 13.5002L9.98346 19.3335M6.62657 7.09673L6.62998 8.87224C6.63032 9.04559 6.63048 9.13226 6.61363 9.2152C6.59868 9.28878 6.57385 9.36 6.53981 9.42693C6.50146 9.50237 6.44744 9.57016 6.33941 9.70573L5.03441 11.3434C4.48097 12.038 4.20424 12.3852 4.20449 12.6771C4.20471 12.9308 4.32055 13.1707 4.5192 13.3286C4.74762 13.5102 5.19166 13.5094 6.07974 13.5077L13.8647 13.4927C14.7528 13.491 15.1968 13.4901 15.4246 13.3076C15.6226 13.1489 15.7375 12.9086 15.7368 12.6549C15.7359 12.363 15.4578 12.0168 14.9017 11.3244L13.5904 9.69177C13.4819 9.55662 13.4276 9.48904 13.3889 9.41375C13.3547 9.34695 13.3295 9.27582 13.3143 9.2023C13.2971 9.11943 13.297 9.03276 13.2966 8.85941L13.2932 7.0839C13.293 6.98796 13.2929 6.93999 13.2983 6.89268C13.303 6.85064 13.3109 6.80903 13.322 6.7682C13.3344 6.72224 13.3522 6.67767 13.3876 6.58853L14.2235 4.48718C14.4673 3.87414 14.5893 3.56761 14.5377 3.32184C14.4926 3.10691 14.3645 2.91847 14.1812 2.79749C13.9716 2.65914 13.6418 2.65977 12.982 2.66104L6.92076 2.67271C6.261 2.67398 5.93112 2.67462 5.72208 2.81377C5.53927 2.93546 5.41189 3.12439 5.36762 3.33949C5.317 3.58546 5.44011 3.89151 5.68631 4.50361L6.53025 6.60173C6.56605 6.69073 6.58395 6.73524 6.59657 6.78115C6.60778 6.82194 6.61587 6.86352 6.62077 6.90553C6.62629 6.95282 6.62638 7.00079 6.62657 7.09673Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1725_25467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0153809 1.01929) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin01);
export default __webpack_public_path__ + "static/media/pin-01.571ea499cb9d6d915e0f21456189a71e.svg";
export { ForwardRef as ReactComponent };